import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-body pt-6 pb-5" }
const _hoisted_2 = {
  key: 0,
  class: "notice bg-light-danger rounded border-danger border border-dashed p-4 mb-5 fs-7 text-gray-800"
}
const _hoisted_3 = { class: "d-flex align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon-fill text-danger me-2 fs-5" }, null, -1)
const _hoisted_5 = { class: "flex-grow-1 umt-wrongcancel" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder mb-2" }, "Phiếu nhập học đã chốt bị hủy nhầm", -1)
const _hoisted_7 = { class: "d-flex mb-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted flex-shrink-0",
  style: {"width":"92px"}
}, "Đã hủy", -1)
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-muted flex-shrink-0",
  style: {"width":"92px"}
}, "Đang dùng", -1)
const _hoisted_12 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "không xác nhận hoàn tất được", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 fw-semibold" }, "Chưa khôi phục được phiếu cũ vì:", -1)
const _hoisted_15 = { class: "mb-0 ps-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 fw-semibold" }, "Nếu khôi phục, phải xử lý tiếp:", -1)
const _hoisted_17 = { class: "mb-0 ps-4 text-muted" }
const _hoisted_18 = {
  key: 3,
  class: "mt-3 d-flex flex-wrap align-items-center gap-2"
}
const _hoisted_19 = ["disabled", "title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle fs-4" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 1,
  class: "text-muted fst-italic fs-8 mb-4 umt-wrongcancel"
}
const _hoisted_23 = {
  id: "kt_customer_view_statement_tab_content",
  class: "tab-content"
}
const _hoisted_24 = {
  id: "kt_customer_view_statement_1",
  class: "py-0 tab-pane fade active show reg-list-styled umt-table umt-form",
  role: "tabpanel"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["id", "onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_32 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_33 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_34 = { class: "d-flex align-items-center justify-content-end gap-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-receipt fs-5" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope fs-5" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-award" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_50 = {
  type: "button",
  class: "btn btn-sm btn-light-primary d-none",
  "data-bs-toggle": "modal",
  ref: "kt_modal_lock_ad",
  "data-bs-target": "#kt_modal_lock_ad"
}
const _hoisted_51 = {
  class: "modal fade umt-form",
  id: "kt_modal_lock_ad",
  ref: "lockAdModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered mw-550px" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = {
  class: "modal-header p-3",
  id: "kt_modal_add_customer_header"
}
const _hoisted_55 = { class: "fw-bolder" }
const _hoisted_56 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_57 = { class: "svg-icon svg-icon-1" }
const _hoisted_58 = { class: "modal-body py-4 px-lg-6" }
const _hoisted_59 = { class: "notice bg-light-warning rounded border-warning border border-dashed p-4 mb-4 fs-7 text-gray-800" }
const _hoisted_60 = { class: "d-flex align-items-start" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("b", null, "nhập học chính thức", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("b", { class: "text-danger" }, "Đã hủy", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("b", { class: "text-danger" }, "không thể khôi phục", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("b", null, "xác nhận hoàn tất", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("b", null, "chuyển giao SIS", -1)
const _hoisted_67 = { class: "d-flex gap-5" }
const _hoisted_68 = { class: "fv-row flex-md-root" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Ngành nhập học", -1)
const _hoisted_70 = { class: "fv-row flex-md-root" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Loại đào tạo", -1)
const _hoisted_72 = { class: "fv-row mt-4" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required fw-bolder" }, "Lý do đổi hồ sơ nhập học", -1)
const _hoisted_74 = {
  key: 0,
  class: "text-danger fs-8 mt-1"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer py-3 px-lg-6" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "btn btn-light umt-btn-32",
    "data-bs-dismiss": "modal"
  }, "Hủy bỏ"),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn btn-primary umt-btn-32",
    type: "submit"
  }, "Mở khóa hồ sơ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ApplicantQuickDrawer = _resolveComponent("ApplicantQuickDrawer")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.cardClasses}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.wrongCancel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.wrongCancel.cancelled?.label), 1),
                    _createElementVNode("span", _hoisted_9, [
                      _createTextVNode(" — đã hoàn tất nhập học"),
                      (_ctx.wrongCancel.cancelled?.handedOver)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" & chuyển giao SIS")
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.wrongCancel.cancelled?.studentCode)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(" · MSSV " + _toDisplayString(_ctx.wrongCancel.cancelled.studentCode), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.wrongCancel.current?.label), 1)
                  ])
                ]),
                (!_ctx.isSuperAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createTextVNode(" Phiếu mới "),
                      _hoisted_13,
                      _createTextVNode(" — giữ nguyên hiện trạng và báo Quản trị xử lý. ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.wrongCancel.blockers?.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_14,
                      _createElementVNode("ul", _hoisted_15, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wrongCancel.blockers, (b, i) => {
                          return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(b), 1))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.wrongCancel.notes?.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_16,
                      _createElementVNode("ul", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wrongCancel.notes, (n, i) => {
                          return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(n), 1))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isSuperAdmin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-sm umt-btn-32", _ctx.wrongCancel.canRestore ? 'btn-light-danger' : 'btn-light text-muted']),
                        disabled: !_ctx.wrongCancel.canRestore,
                        title: _ctx.wrongCancel.canRestore ? 'Quay về phiếu cũ, xóa phiếu mới' : 'Xử lý các vướng mắc ở trên rồi mới khôi phục được',
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restoreWrongCancel()))
                      }, " Khôi phục phiếu cũ ", 10, _hoisted_19),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-primary umt-btn-32",
                        title: "Giữ phiếu mới và đi tiếp",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.acceptWrongCancel()))
                      }, " Chấp nhận phiếu mới "),
                      _createElementVNode("span", {
                        class: "btn btn-sm btn-icon btn-active-light-primary text-primary umt-btn-32",
                        title: "Bấm mỗi nút thì chuyện gì xảy ra?",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showWrongCancelInfo()))
                      }, _hoisted_21)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_ctx.wrongCancelResolved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Đã chấp nhận tiếp tục theo phiếu " + _toDisplayString(_ctx.wrongCancelResolved.currentLabel) + " (thay cho " + _toDisplayString(_ctx.wrongCancelResolved.cancelledLabel) + " đã hủy) — " + _toDisplayString(_ctx.wrongCancelResolved.resolved?.by) + ". Lý do: " + _toDisplayString(_ctx.wrongCancelResolved.resolved?.reason), 1))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_Datatable, {
            "table-header": _ctx.tableHeader,
            "table-data": _ctx.tableData ? _ctx.tableData : [],
            "rows-per-page": 25,
            "enable-items-per-page-dropdown": false,
            classTable: "table-row-bordered"
          }, {
            "cell-phase": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.rowToDetail(customer))
              }, " Đợt " + _toDisplayString(customer.phase), 9, _hoisted_25)
            ]),
            "cell-createdAt": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.rowToDetail(customer))
              }, _toDisplayString(customer.createdAt), 9, _hoisted_26)
            ]),
            "cell-profileCode": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: "cursor-pointer text-primary fw-bold",
                title: "Xem nhanh phiếu nhập học",
                onClick: ($event: any) => (_ctx.openApplicantQuickView(customer))
              }, _toDisplayString(customer.profileCode), 9, _hoisted_27)
            ]),
            "cell-major": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.rowToDetail(customer))
              }, _toDisplayString(customer.major), 9, _hoisted_28)
            ]),
            "cell-status": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: "cursor-pointer text-center label_adm",
                id: `label_adm_${customer.id}`,
                onClick: ($event: any) => (_ctx.rowToDetail(customer))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(`m-auto badge badge-light-${_ctx.optionsStatus.find(e=>e.value==customer.status)?.color}`)
                }, _toDisplayString(_ctx.optionsStatus.find(e=>e.value==customer.status)?.name), 3)
              ], 8, _hoisted_29)
            ]),
            "cell-confirm": _withCtx(({ row: customer }) => [
              _createElementVNode("div", {
                class: "text-center cursor-pointer",
                onClick: ($event: any) => (_ctx.rowToDetail(customer))
              }, [
                (customer.status != 'opened')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "—"))
                  : (customer.applicantStatus == 'confirmed')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Đã xác nhận"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_33, "Chưa xác nhận"))
              ], 8, _hoisted_30)
            ]),
            "cell-action": _withCtx(({ row: customer }) => [
              _createElementVNode("div", _hoisted_34, [
                (customer.status == 'opened')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.rowToDetail(customer)),
                      class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
                      title: "Mở chi tiết thủ tục nhập học"
                    }, [
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/art/art005.svg" })
                      ])
                    ], 8, _hoisted_35))
                  : _createCommentVNode("", true),
                (customer.status == 'opened' && customer.applicantStudentCode)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.getPdf(customer)),
                      class: "btn btn-sm btn-icon btn-light-primary",
                      title: "In phiếu thông tin sinh viên"
                    }, [
                      _createElementVNode("span", _hoisted_38, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/printer.svg" })
                      ])
                    ], 8, _hoisted_37)), [
                      [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_PRINT, _ctx.Permission.ADMISSION_REGISTER]]
                    ])
                  : _createCommentVNode("", true),
                (customer.status == 'opened' && ['completed','confirmed'].includes(customer.applicantStatus))
                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                      key: 2,
                      onClick: ($event: any) => (_ctx.gotoReceiptTicket(customer)),
                      class: "btn btn-sm btn-icon btn-light-primary",
                      title: "In phiếu tiếp nhận hồ sơ"
                    }, _hoisted_41, 8, _hoisted_39)), [
                      [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_PRINT, _ctx.Permission.ADMISSION_REGISTER]]
                    ])
                  : _createCommentVNode("", true),
                (customer.status == 'opened' && customer.applicantStatus == 'confirmed')
                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                      key: 3,
                      onClick: ($event: any) => (_ctx.sendFeeMail(customer)),
                      class: "btn btn-sm btn-icon btn-light-info",
                      title: "Gửi email báo phí"
                    }, _hoisted_44, 8, _hoisted_42)), [
                      [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EMAIL, _ctx.Permission.ADMISSION_REGISTER]]
                    ])
                  : _createCommentVNode("", true),
                (customer.status == 'opened' && customer.applicantStatus == 'confirmed')
                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                      key: 4,
                      onClick: ($event: any) => (_ctx.printUuDai(customer)),
                      class: "btn btn-sm btn-icon btn-light-success",
                      title: "In phiếu xác nhận ưu đãi/học bổng"
                    }, _hoisted_47, 8, _hoisted_45)), [
                      [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_PRINT, _ctx.Permission.ADMISSION_REGISTER]]
                    ])
                  : _createCommentVNode("", true),
                (customer.status == 'none' && !_ctx.wrongCancel)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", {
                      key: 5,
                      class: "btn btn-sm btn-icon btn-light-warning",
                      title: "Mở khóa hồ sơ",
                      onClick: e=>{
                                        _ctx.callModalAddApp(e)
                                        _ctx.formData.profileCode = customer.profileCode
                                        _ctx.formData.major = customer.major
                                        _ctx.getTuition(customer.majorCode)
                                    }
                    }, [
                      _createElementVNode("span", _hoisted_49, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/unlock.svg" })
                      ])
                    ], 8, _hoisted_48)), [
                      [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_EDIT_STATUS, _ctx.Permission.ADMISSION_REGISTER]]
                    ])
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["table-header", "table-data"])
        ])
      ])
    ]),
    _createElementVNode("button", _hoisted_50, null, 512),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("h2", _hoisted_55, "Mở khóa hồ sơ " + _toDisplayString(_ctx.formData.profileCode), 1),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("span", _hoisted_57, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.unlockProfile()), ["prevent"])),
              model: _ctx.formData,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("div", null, [
                        _createTextVNode(" Mở khóa = chọn hồ sơ "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.formData.profileCode), 1),
                        _createTextVNode(" làm hồ sơ "),
                        _hoisted_62,
                        _createTextVNode(" của ứng viên. Hồ sơ đang \"Chọn nhập học\" hiện tại (nếu có) cùng phiếu đăng ký thông tin của nó sẽ chuyển sang "),
                        _hoisted_63,
                        _createTextVNode(" và "),
                        _hoisted_64,
                        _createTextVNode(" — hồ sơ đã hủy không dùng để đăng ký nhập học lại được. Hồ sơ đã "),
                        _hoisted_65,
                        _createTextVNode(" hoặc đã "),
                        _hoisted_66,
                        _createTextVNode(" sẽ bị từ chối. ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _hoisted_69,
                      _createVNode(_component_el_input, {
                        class: "form-select-solid w-100",
                        readonly: "",
                        modelValue: _ctx.formData.major,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.major) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _hoisted_71,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid w-100",
                        placeholder: "Loại Đào tạo",
                        modelValue: _ctx.formData.programtype,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.programtype) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsPrograms, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      type: "textarea",
                      rows: 2,
                      modelValue: _ctx.formData.reason,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.reason) = $event)),
                      placeholder: "VD: Ứng viên xin đổi ngành, đã có xác nhận của TTV/phụ huynh…",
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.reasonError = ''))
                    }, null, 8, ["modelValue"]),
                    (_ctx.formData.reasonError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, _toDisplayString(_ctx.formData.reasonError), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_75
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ])
    ], 512),
    _createVNode(_component_ApplicantQuickDrawer, { ref: "applicantQuickDrawer" }, null, 512)
  ], 2)), [
    [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_VIEW, _ctx.Permission.ADMISSION_REGISTER]]
  ])
}